import ApiService from './ApiService';

export default class PvApiService extends ApiService {

    getGranularToday () {
        return new Promise((resolve, reject) => {
            this.get('/pv/gemeinde-bad-wimsbach/pvvbwn/granular/today').
                then((response) => {
                    if (response.success) {
                        resolve(response.granularData);
                    }
                    else {
                        reject('Something went wrong');
                    }
                });
        });

    }

    getGeneralToday () {
        return new Promise((resolve, reject) => {
            this.get('/pv/gemeinde-bad-wimsbach/pvvbwn/general/today').
                then((response) => {
                    if (response.success) {
                        resolve(response.energy);
                    }
                    else {
                        reject('Something went wrong');
                    }
                });
        });
    }

}